import { render } from "./PhotoVideos.vue?vue&type=template&id=f6288b3a"
import script from "./PhotoVideos.vue?vue&type=script&lang=js"
export * from "./PhotoVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__